import axios from "axios";
import { otherApiClient } from ".";
export const getSignUpBenefit = async ()=>{
    const { data  } = await otherApiClient.market.get("/signUp/guest");
    return data;
};
export const getMemberSignUpCheck = async (params)=>{
    const { data  } = await otherApiClient.market.get("/signUp/lookUp", {
        params
    });
    return data;
};
export const getSchools = async (params)=>{
    const { data  } = await otherApiClient.market("/signup/schools", {
        params
    });
    return data;
};
export const claimSignupRewards = async ()=>{
    try {
        const { data  } = await otherApiClient.market.post("/signUp/completed/rewards", {});
        return data;
    } catch (error) {
        var _error_response;
        // 404 = 매칭 정책 없음(정상 케이스) → null 반환해 에러/리트라이 없이 "혜택 없음"으로 처리
        if (axios.isAxiosError(error) && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) return null;
        throw error;
    }
};
export const claimSignupPromotion = async ()=>{
    const { data  } = await otherApiClient.market.post("/signUp/completed/promotion", {});
    return data;
};
